export interface DadosSerieVariavelMeteorologica {
	eixo: Object;
	serie: Object[];
}

export interface DadosGraficoVariaveis {
	datas: any[];
	periodo?: string;
}

export abstract class SerieVariavelMeteorologica {
	abstract obterDadosSerie(
		dadosGrafico: DadosGraficoVariaveis,
		indexEixo: number
	): DadosSerieVariavelMeteorologica;

	/**
	 * Formata o dado no array de da série entendida pelo highchart.
	 * @returns {any[]} um objeto que representa a série
	 */
	protected prepararSerie(
		datas: Date[] | number[],
		valores: number[],
		periodo?: string
	): any {
		const serie = [];
		const tamanho = datas.length;
		const valoresCorrigidos = valores.map(dado => {
			if (dado === undefined || dado === null) {
				return null;
			} else {
				return Number(dado.toFixed(2));
			}
		});
		if (
			periodo === 'diario' ||
			periodo === undefined ||
			periodo === null ||
			periodo === 'mensal' ||
			periodo === 'anual'
		) {
			for (let i = 0; i < tamanho; i++) {
				const rawDate = datas[i];
				const valor = valoresCorrigidos[i];

				if (!rawDate || valor === undefined) {
					console.warn('Valor ou data inválida:', { i, rawDate, valor });
					continue;
				}

				const dateObj =
					typeof rawDate === 'number'
						? new Date(rawDate)
						: rawDate instanceof Date
						? rawDate
						: new Date(rawDate);

				if (isNaN(dateObj.getTime())) {
					console.warn('Data inválida:', rawDate);
					continue;
				}
				if (periodo === 'diario') {
					dateObj.setHours(dateObj.getHours() - 3);
				}

				const timestamp = dateObj.getTime();

				serie.push([timestamp, valor]);
			}
		}

		return serie;
	}
}
